import { render, staticRenderFns } from "./theProjectColumn.vue?vue&type=template&id=936d7cfe&scoped=true"
import script from "./theProjectColumn.vue?vue&type=script&lang=js"
export * from "./theProjectColumn.vue?vue&type=script&lang=js"
import style0 from "./../style.scss?vue&type=style&index=0&id=936d7cfe&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936d7cfe",
  null
  
)

export default component.exports